// frontend/src/farm/animalRoam.mjs — farm animal helpers (pure). Since 4d the server decides
// where animals walk (backend herd_brain.py); what stays here: blocked cells, the spot in front
// of a hut (the fallback before the stream arrives), sizing against the character, the night.
import { cellKey, inFarm } from './iso.mjs';
import { occupiedCells } from './farmRules.mjs';

export function blockedFor(state) {
  const size = state.farm.size; const cells = state.farm.cells ?? {}; const taken = occupiedCells(state);
  return (x, y) => !inFarm({ x, y }, size) || !!cells[cellKey(x, y)] || taken.has(cellKey(x, y));
}

// The grass just in front of the hut's front corner, else the nearest free cell (BFS).
export function homeCell(state, animal) {
  const hut = (state.placements ?? []).find((p) => p.id === animal.buda_placement_id);
  const spec = hut && state.catalog.farm.objects[hut.item];
  const start = hut && spec ? { x: hut.x + spec.w, y: hut.y + spec.h } : { x: 0, y: 0 };
  return nearestFree(state, start);
}
export function nearestFree(state, start) {
  const b = blockedFor(state); const size = state.farm.size;
  const seen = new Set();
  const q = [{ x: Math.min(Math.max(start.x, 0), size - 1), y: Math.min(Math.max(start.y, 0), size - 1) }];
  while (q.length) {
    const c = q.shift(); const k = cellKey(c.x, c.y);
    if (seen.has(k)) continue; seen.add(k);
    if (!b(c.x, c.y)) return c;
    for (const [dx, dy] of [[1, 0], [-1, 0], [0, 1], [0, -1]]) {
      const n = { x: c.x + dx, y: c.y + dy };
      if (inFarm(n, size)) q.push(n);
    }
  }
  return null;
}




// Sizes against the character (owner: realistic proportions). Natalka stands ~144 px on the farm
// (measured, OUTDOOR_CHARACTER_SCALE); a child ~1.4 m, a cow ~1.45 m at the shoulder, a hen ~0.4 m.
export const CHARACTER_H = 144;
const HEIGHT_OF = { krowa: 0.665, kura: 0.3 };      // × the character's height (the cow 30 % under life-size: owner)
// The display scale for a species, from its walk0 frame's source height (one scale for all its
// frames, so the grazing / pecking pose isn't blown up to the same height).
export function animalScale(type, walk0SrcH) {
  const f = HEIGHT_OF[type];
  return f && walk0SrcH > 0 ? (f * CHARACTER_H) / walk0SrcH : null;
}

export const isNight = (t) => t < 60;       // skyClock: night is 0–60 of the 240 s cycle
